import _ from 'lodash'

export function saveUser(user){
    localStorage.setItem("user", JSON.stringify(user));
}

export function saveToken(token){
    localStorage.setItem("token", token);
}

export function saveAbp(abpData){
    localStorage.setItem("abp", JSON.stringify(abpData));
}

export function getUser(){
    return JSON.parse(localStorage.getItem("user"));
}

export function getToken(){
    return localStorage.getItem("token");
}

export function getAbp(){
    return JSON.parse(localStorage.getItem("abp"));
}

export function clearSession(){
    localStorage.clear();
}